module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-row"
  }, [_c('cat-score-column', {
    attrs: {
      "categoryName": _vm.category.name,
      "columnAScore": _vm.columnAScores.score,
      "columnBScore": _vm.columnBScores.score,
      "catIndex": _vm.catIndex
    }
  }), _vm._v(" "), _c('subcat-score-column', {
    attrs: {
      "subcategories": _vm.category.subcategories,
      "columnAsubcats": _vm.columnAScores.subcategories,
      "columnBsubcats": _vm.columnBScores.subcategories
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9fc250","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comparison/CategoryRow.vue
// module id = 532
// module chunks = 1